import { Box, CircularProgress } from '@mui/material'

export function LoadingPanel() {
    return (
        <Box
            sx={{
                display: 'grid',
                placeItems: 'center',
                minHeight: '100%',
            }}
        >
            <CircularProgress />
        </Box>
    )
}
